import { PropTypes } from 'prop-types'
import { motion } from "framer-motion";
import { animateProps } from 'utils/GeneralAnimateProps';
const AnimatedSpan = ({children, className}) => {
  return (
    <motion.span className={className && className} {...animateProps}>{children}</motion.span>
  )
}
AnimatedSpan.propTypes = {
	children: PropTypes.node,
  className: PropTypes.string
}
export default AnimatedSpan